import { useState, useEffect } from "react";
import DetailsView from "../../../components/Views/DetailsView/DetailsView";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import KeyPosVisited from "./KeyPosVisited";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { actions as commonActions } from "../../../store/actions";
import InputFrames from "../../../components/Frames/InputFrames";
import { actions } from "../state/actions";
import { useTranslation } from "react-i18next";
import "../KeyPos.scss";

const KeyPosEdit = () => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [POSVisited, setPosVisited] = useState(0);
  const [POSActivatable, setPOSActivatable] = useState(0);
  const commonState = useSelector((state) => state.common);
  const state = useSelector((state) => state.keyPos);
  const dispatch = useDispatch();
  const urlParams = useParams();
  const history = useHistory();
  const [isEdited, setIsEdited] = useState(false);
  const [isVistedChanged, setIsVisitedChanged] = useState(false);
  const { t } = useTranslation();
  const menuState = useSelector((state) => state.menus);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const pageName = "Key Pos";
  const [error, setError] = useState({
    status: false,
    POSEZDPOSCode: "",
    POSPOSISPOSCode: "",
    POSLegalName: "",
    POSVisited: 0,
    POSActivatable: 0,
    POSDecentralized: 0,
    KAChainDescription: "",
    KeyPOSChannelCode: "",
    KeyPOSLocationCode: "",
    KeyPOSKAOwner: "",
    KeyPOSKAAgreement: "",
    KeyPOSHotZone: 0,
    KeyPOSCigarCase: "",
    KeyPOSCigarType: "",
    KeyPOSQuantityOfModules: "",
    KeyPOSSecondaryMaterialCode: "",
  });
  const isDsd = state?.keyPosEdit?.is_dsd;

  useEffect(() => {
    dispatch(commonActions.setLoading(true));
    dispatch(actions.getKeyPosById(urlParams.id));

    if (commonState.redirect) {
      dispatch(commonActions.setRedirect(false));
      history.push("/keypos");
    }
  }, [commonState.redirect]);

  useEffect(() => {
    if (state?.keyPosEdit.POSVisited === 1) {
      setIsEdited(true);
    } else {
      setIsEdited(false);
    }
  }, [state?.keyPosEdit.POSVisited]);

  useEffect(() => {
    const readonly = menuState?.data?.readOnly?.[pageName] === 1 ? true : false;
    setIsReadOnly(readonly);
  }, [menuState?.data?.readOnly?.[pageName]]);

  useEffect(() => {
    if (state?.fieldControls?.length === 0) {
      dispatch(actions.getDynamicFieldControls({ params: "customerType,cigarCase" }))
    }
  }, [])

  const handleChangeField = ({ target: { name, value } }) => {
    dispatch(actions.setKeyPosEditForm({ name, value }));
    if (name === "POSVisited") {
      setPosVisited(value);
      setIsVisitedChanged(!isVistedChanged);
    } 
    if (name === "POSActivatable") {
      setPOSActivatable(value);
    }
    setIsDisabled(false);
  };

  const handleFormSubmit = () => {
    const {
      POSSK,
      POSLegalName,
      POSStreet,
      POSStreetNumber,
      POSCity,
      POSDistrict,
      POSXCoordinate,
      POSYCoordinate,
      POSAlternateXCoordinate,
      POSAlternateYCoordinate,
      POSActivatable,
      POSVisited,
      POSDecentralized,
      KeyPOSHotZone,
      KAChainCustTypeDesc,
      KAChainSK,
      KAChainDescription,
      KeyPOSChannelSK,
      KeyPOSChannelDescription,
      KeyPOSLocationSK,
      KeyPOSLocationDescription,
      KeyPOSKAOwnerSK,
      KeyPOSKAOwnerDescription,
      KeyPOSKAAgreementSK,
      KeyPOSKAAgreementDescription,
      KeyPOSCigarCaseSK,
      KeyPOSCigarCaseDescription,
      KeyPOSCigarTypeSK,
      KeyPOSCigarTypeDescription,
      KeyPOSQuantityOfModulesSK,
      KeyPOSQuantityOfModulesDescription,
      KeyPOSSecondaryMaterialCodeSK,
      KeyPOSSecondaryMaterialCodeDescription,
      KeyPOSDigitalCoverage,
    } = state?.keyPosEdit;

    // if (!KeyPOSChannelCode) {
    //   setError((prevState) => ({
    //     ...prevState,
    //     status: true,
    //     KeyPOSChannelCode: "Channel Code cant be empty",
    //   }));
    //   return;
    // }

    // if (isEdited) {
    //   const payload = {
    //     POSSK,
    //     POSActivatable,
    //     POSVisited,
    //     POSDecentralized,
    //     KeyPOSHotZone,
    //     KAChainCustTypeDesc,
    //     KAChainSK,
    //     KAChainDescription,
    //     KeyPOSChannelSK,
    //     KeyPOSChannelDescription,
    //     KeyPOSLocationSK,
    //     KeyPOSLocationDescription,
    //     KeyPOSKAOwnerSK,
    //     KeyPOSKAOwnerDescription,
    //     KeyPOSKAAgreementSK,
    //     KeyPOSKAAgreementDescription,
    //     KeyPOSCigarCaseSK,
    //     KeyPOSCigarCaseDescription,
    //     KeyPOSCigarTypeSK,
    //     KeyPOSCigarTypeDescription,
    //     KeyPOSQuantityOfModulesSK,
    //     KeyPOSQuantityOfModulesDescription,
    //     KeyPOSSecondaryMaterialCodeSK,
    //     KeyPOSSecondaryMaterialCodeDescription,
    //     KeyPOSDigitalCoverage,
    //     userId: commonState.userInfo.principalName,
    //     countrySk: commonState.userInfo.countrySk,
    //   };
    //   dispatch(actions.createChildPos(payload));
    // } else if (
    //   (!isEdited && isVistedChanged) ||
    //   (!isEdited && !isVistedChanged)
    // ) {
    //   const payload = {
    //     POSSK,
    //     POSActivatable,
    //     POSVisited: 0,
    //     POSDecentralized,
    //     userId: commonState.userInfo.principalName,
    //     countrySk: commonState.userInfo.countrySk,
    //   };
    //   dispatch(actions.updateKeyPos(payload));
    // } else {
      const payload = {
        POSSK,
        POSLegalName,
        POSStreet,
        POSStreetNumber,
        POSCity,
        POSDistrict,
        POSXCoordinate,
        POSYCoordinate,
        POSAlternateXCoordinate,
        POSAlternateYCoordinate,
        POSActivatable,
        POSVisited,
        POSDecentralized,
        KeyPOSHotZone,
        KAChainCustTypeDesc,
        KAChainSK,
        KAChainDescription,
        KeyPOSChannelSK,
        KeyPOSChannelDescription,
        KeyPOSLocationSK,
        KeyPOSLocationDescription,
        KeyPOSKAOwnerSK,
        KeyPOSKAOwnerDescription,
        KeyPOSKAAgreementSK,
        KeyPOSKAAgreementDescription,
        KeyPOSCigarCaseSK,
        KeyPOSCigarCaseDescription,
        KeyPOSCigarTypeSK,
        KeyPOSCigarTypeDescription,
        KeyPOSQuantityOfModulesSK,
        KeyPOSQuantityOfModulesDescription,
        KeyPOSSecondaryMaterialCodeSK,
        KeyPOSSecondaryMaterialCodeDescription,
        KeyPOSDigitalCoverage,
        userId: commonState.userInfo.principalName,
        countrySk: commonState.userInfo.countrySk,
      };
      console.log(payload);
      dispatch(actions.updateKeyPos(payload));
    // }
    dispatch(commonActions.setUpdated(true));
  };

  const handleFormCancel = () => {
    history.push("/keypos");
  };

  const handleDigitalCoverageChange = (event) => {
    dispatch(
      actions.setKeyPosEditForm({
        name: "KeyPOSDigitalCoverage",
        value: event.target.value,
      })
    );
    setIsDisabled(false);
  };

  const handleChildPosChange = (event, value, key, sk) => {
    if (key === "KAChainDescription") {
      dispatch(
        actions.setKeyPosEditForm({
          name: "KAChainDescription",
          value: value?.KAChainDescription || "",
        })
      );
      dispatch(
        actions.setKeyPosEditForm({
          name: sk,
          value: value?.KAChainSK || "",
        })
      );

      dispatch(
        actions.setKeyPosEditForm({
          name: "KAChainCustTypeDesc",
          value: value?.KAChainCustTypeDesc || "",
        })
      );
      dispatch(
        actions.setKeyPosEditForm({
          name: "KAChainCustTypeDesc",
          value: value?.KAChainCustTypeDesc || "",
        })
      );

      setIsDisabled(false);
      return;
    }
    if (key === "KeyPOSHotZone" || key === "POSDecentralized") {
      dispatch(
        actions.setKeyPosEditForm({
          name: key,
          value: event.target.value || 0,
        })
      );
      setIsDisabled(false);
      return;
    }

    dispatch(
      actions.setKeyPosEditForm({
        name: key,
        value: value ? value[key] : "",
      })
    );
    dispatch(
      actions.setKeyPosEditForm({
        name: sk,
        value: value ? value[sk] : "",
      })
    );

    setIsDisabled(false);
    setError((prevState) => ({
      ...prevState,
      status: false,
      POSEZDPOSCode: "",
      POSPOSISPOSCode: "",
      POSLegalName: "",
      POSVisited: 0,
      POSActivatable: 0,
      POSDecentralized: 0,
      KAChainDescription: "",
      KeyPOSChannelCode: "",
      KeyPOSLocationCode: "",
      KeyPOSKAOwner: "",
      KeyPOSKAAgreement: "",
      KeyPOSHotZone: 0,
      KeyPOSCigarCase: "",
      KeyPOSCigarType: "",
      KeyPOSQuantityOfModules: "",
      KeyPOSSecondaryMaterialCode: "",
    }));
  };

  return (
    <DetailsView
      heading="Edit Key Pos"
      onSubmit={handleFormSubmit}
      onCancel={handleFormCancel}
      isDisabled={isDisabled}
    >
      {state?.keyPosEdit &&
      Object.keys(state.keyPosEdit).length > 0 &&
      !commonState.loading ? (
        <form className="details__view__body__form">
          <Grid container spacing={4}>
            <Grid item sm={4}>
              <TextField
                variant="outlined"
                name="POSPOSISPOSCode"
                label={t(`Posis Pos Code`)}
                size="small"
                // fullWidth
                // style={{ minWidth: 230 }}
                value={state?.keyPosEdit?.POSPOSISPOSCode || ""}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                variant="outlined"
                name="POSEZDPOSCode"
                label={t(`Ezd Pos Code`)}
                size="small"
                // fullWidth
                // style={{ maxWidth: 220 }}
                value={state?.keyPosEdit?.POSEZDPOSCode || ""}
                InputLabelProps={{ shrink: true }}
                disabled
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                variant="outlined"
                name="POSLegalName"
                label={t(`Legal Name`)}
                size="small"
                value={state?.keyPosEdit?.POSLegalName || ""}
                InputLabelProps={{ shrink: true }}
                onChange={handleChangeField}
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                variant="outlined"
                name="POSStreet"
                label={t(`Street`)}
                size="small"
                disabled={!isDsd}
                value={state?.keyPosEdit?.POSStreet || ""}
                InputLabelProps={{ shrink: true }}
                onChange={handleChangeField}
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                type="number"
                variant="outlined"
                name="POSStreetNumber"
                label={t(`Pos Street Number`)}
                size="small"
                disabled={!isDsd}
                value={state?.keyPosEdit?.POSStreetNumber || ""}
                InputLabelProps={{ shrink: true }}
                onChange={handleChangeField}
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                variant="outlined"
                name="POSCity"
                label={t(`City`)}
                size="small"
                disabled={!isDsd}
                value={state?.keyPosEdit?.POSCity || ""}
                InputLabelProps={{ shrink: true }}
                onChange={handleChangeField}
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                variant="outlined"
                name="POSDistrict"
                label={t(`District`)}
                size="small"
                disabled={!isDsd}
                value={state?.keyPosEdit?.POSDistrict || ""}
                InputLabelProps={{ shrink: true }}
                onChange={handleChangeField}
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                variant="outlined"
                name="POSXCoordinate"
                label={t(`POS X Coordinate`)}
                size="small"
                disabled={!isDsd}
                value={state?.keyPosEdit?.POSXCoordinate || ""}
                InputLabelProps={{ shrink: true }}
                onChange={handleChangeField}
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                variant="outlined"
                name="POSYCoordinate"
                label={t(`POS Y Coordinate`)}
                size="small"
                disabled={!isDsd}
                value={state?.keyPosEdit?.POSYCoordinate || ""}
                InputLabelProps={{ shrink: true }}
                onChange={handleChangeField}
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                variant="outlined"
                name="POSAlternateXCoordinate"
                label={t(`POS Alternate X Coordinate`)}
                size="small"
                value={state?.keyPosEdit?.POSAlternateXCoordinate || ""}
                InputLabelProps={{ shrink: true }}
                onChange={handleChangeField}
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                variant="outlined"
                name="POSAlternateYCoordinate"
                label={t(`POS Alternate Y Coordinate`)}
                size="small"
                value={state?.keyPosEdit?.POSAlternateYCoordinate || ""}
                InputLabelProps={{ shrink: true }}
                onChange={handleChangeField}
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                select
                variant="outlined"
                style={{ minWidth: 220 }}
                value={state?.keyPosEdit?.POSActivatable || POSActivatable}
                InputLabelProps={{ shrink: true }}
                disabled={isReadOnly}
                name="POSActivatable"
                onChange={handleChangeField}
                label={t(`Activable`)}
                size="small"
              >
                <MenuItem value={1}>Yes</MenuItem>
                <MenuItem value={0}>No</MenuItem>
              </TextField>
            </Grid>
            <Grid item sm={4}>
              <TextField
                select
                variant="outlined"
                style={{ minWidth: 220 }}
                value={state?.keyPosEdit?.POSVisited || POSVisited}
                name="POSVisited"
                disabled={isReadOnly}
                onChange={handleChangeField}
                InputLabelProps={{ shrink: true }}
                label={t(`Visited`)}
                size="small"
              >
                <MenuItem value={1}>Yes</MenuItem>
                <MenuItem value={0}>No</MenuItem>
              </TextField>
            </Grid>
            <Grid item sm={4} lg={4} xs={12}>
              <TextField
                variant="outlined"
                size="small"
                InputLabelProps={{ shrink: true }}
                disabled
                // style={{ maxWidth: 250 }}
                value={
                  state?.keyPosEdit?.child_Count &&
                  !state?.keyPosEdit?.POS_ParentPOSSK
                    ? "Parent"
                    : !state?.keyPosEdit?.child_Count &&
                      !state?.keyPosEdit?.POS_ParentPOSSK
                    ? "Other"
                    : "Child"
                }
                name="posType"
                label={t(`Pos Type`)}
              />
            </Grid>
          </Grid>

          <Grid style={{ marginTop: 20 }} container spacing={3}>
            {/* {state?.keyPosEdit?.POSVisited === 1 && ( */}
              <KeyPosVisited
                keyPosInfo={state?.keyPosEdit}
                handleChildPosChange={handleChildPosChange}
                handleDigitalCoverageChange={handleDigitalCoverageChange}
                // childPos={childPos}
                readOnly={isReadOnly}
                error={error}
              />
             {/* )} */}
          </Grid>
        </form>
      ) : (
        <InputFrames />
      )}
    </DetailsView>
  );
};

export default KeyPosEdit;
